'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

GroupUpdateErrorHandlingService=function(_BaseService){_inherits(GroupUpdateErrorHandlingService,_BaseService);_createClass(GroupUpdateErrorHandlingService,null,[{key:'$inject',get:function()
{
return['notificationService'];
}}]);

function GroupUpdateErrorHandlingService(notificationService){_classCallCheck(this,GroupUpdateErrorHandlingService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._notificationService=notificationService;return _this;
}GroupUpdateErrorHandlingService.prototype.

handle=function handle(socketResponse){
if(socketResponse.status!=='HttpError'){
this._notificationService.displayNotification(
`An unexpected error occurred updating the group, please contact support (response status: ${socketResponse.status}).`,
'error');
return;
}

let statusCode=_.get(socketResponse,'body.httpStatus');
switch(statusCode){
case 404:
this._notificationService.displayNotification('Sorry, the group you attempted to update no longer exists.','warning');
break;

default:
this._notificationService.displayNotification(
`An unexpected error occurred updating the group, please contact support (status code: ${statusCode}).`,
'error');
break;}

};return GroupUpdateErrorHandlingService}(BaseService);

module.exports=GroupUpdateErrorHandlingService;
//# sourceMappingURL=groupUpdateErrorHandlingService.js.map
